import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';
import { getCountryCallingCode } from 'react-phone-number-input';
import styled from '@emotion/styled';

const OptionItems = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 6px 12px;
  background: white;
  cursor: pointer;
  text-align: left;
  
  &:hover {
    background: #f0f0f0;
  }
  
  &.selected {
    background: #e3f2fd;
  }

  svg {
    width: 16px;
    height: 12px;
  }

  .countryName {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .countryCode {
    font-size: 14px;
    color: #A1A3A6;
  }
`;

const CountryOption = ({ countryCode, label, isSelected, onSelect }) => {
  const Flag = Flags[countryCode];
  const callingCode = getCountryCallingCode(countryCode);

  return (
    <OptionItems
      type="button"
      className={isSelected ? 'selected' : ''}
      onClick={() => onSelect(countryCode)}
    >
      {Flag && <Flag />}
      <span className="countryName">{label}</span>
      <span className="countryCode">+{callingCode}</span>
    </OptionItems>
  );
};

export default CountryOption;
